import { IType } from '../internal';

export const number: IType = {
  name: 'number',
};
